import { EButtonStyleType, ESize } from '@common/enums';

/**
 * Class names for the shared themed-button markup (`sp-ui-button`), used by every
 * widget that renders one: button, social, form, payment-form, login-edu,
 * product-card, testimonial, chat-bot, catalog-products, shop-cart.
 *
 * They live here so the css-vars twins in this package can compose class strings
 * without reaching into the websites app; `apps/websites/.../base-button.const.ts`
 * re-exports them, so its forty-odd consumers are unaffected.
 */

export const DEFAULT_BUTTON_CLASS = 'sp-ui-button';

export const BUTTON_TYPE_CLASS_MAP = {
    [EButtonStyleType.primary]: 'sp-ui-button-primary-light',
    [EButtonStyleType.secondary]: 'sp-ui-button-secondary-light',
};

export const BUTTON_SIZE_CLASS_MAP = {
    [ESize.S]: 'sp-ui-button-sm',
    [ESize.M]: 'sp-ui-button-md',
    [ESize.L]: 'sp-ui-button-lg',
};
